var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "assistant-cat-home", style: _vm.homeBackgroundStyle },
    [
      _c("assistant-cat-home-stage", {
        staticClass: "assistant-cat-home__stage",
        attrs: {
          group: _vm.roomGroup,
          "writer-type": _vm.selectedCatType,
          "cat-name": _vm.catName,
          layout: _vm.artworkLayout,
        },
        on: { "tap-burst": _vm.onCatTapBurst },
      }),
      _c(
        "div",
        { ref: "frame", staticClass: "assistant-cat-home__frame" },
        [
          _c("header", { staticClass: "assistant-cat-home__header" }, [
            _c(
              "button",
              {
                staticClass: "assistant-cat-home__icon-button",
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t("assistantCatHome.back"),
                },
                on: { click: _vm.onBack },
              },
              [_c("icon-arrow-left")],
              1
            ),
            _c(
              "button",
              {
                staticClass: "assistant-cat-home__icon-button",
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t("assistantCatHome.openMenu"),
                },
                on: {
                  click: function ($event) {
                    _vm.isMenuOpen = !_vm.isMenuOpen
                  },
                },
              },
              [_c("icon-hamburger")],
              1
            ),
          ]),
          _c("assistant-cat-home-speech-bubble", {
            staticClass: "assistant-cat-home__speech",
            style: _vm.speechStyle,
            attrs: {
              title: _vm.catName,
              greeting: _vm.greeting,
              username: _vm.displayUsername,
            },
          }),
          _c("assistant-cat-home-action-panel", {
            staticClass: "assistant-cat-home__actions",
            style: _vm.actionsStyle,
            on: { action: _vm.onActionFromPanel },
          }),
        ],
        1
      ),
      _vm.isMenuOpen
        ? _c("assistant-cat-home-menu-sheet", {
            attrs: {
              "fish-label": _vm.formattedCurrentFish,
              "charge-label": _vm.formattedChargeFish,
              "bonus-label": _vm.formattedFreeFish,
              "writer-type": _vm.selectedCatType,
              "feedback-manuscript-mode": _vm.feedbackManuscriptMode,
              "generate-summary-mode": _vm.generateSummaryMode,
            },
            on: {
              close: function ($event) {
                _vm.isMenuOpen = false
              },
              action: _vm.onActionFromSheet,
              charge: _vm.onChargeFromSheet,
              "charge-breakdown": _vm.onChargeBreakdownFromSheet,
            },
          })
        : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "assistant-cat-home-loading" } },
        [
          _vm.showLoadingOverlay
            ? _c("assistant-cat-home-loading", {
                attrs: {
                  "paw-count": _vm.pawCount,
                  "show-retry": _vm.loadError,
                },
                on: { retry: _vm.onRetryLoad },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.showAssistantCatDialog
        ? _c("assistant-cat-selection-dialog", {
            attrs: { "assistant-cat-master": _vm.assistantCatMaster },
            on: { close: _vm.onCloseAssistantCatDialog },
          })
        : _vm._e(),
      _vm.showNicknameInputDialog
        ? _c("cat-nickname-input-dialog", {
            attrs: {
              "assistant-cat": _vm.selectedAssistantCat,
              "initial-nickname": _vm.inputDialogInitialNickname,
            },
            on: { save: _vm.onSaveNickname, cancel: _vm.onCancelNicknameInput },
          })
        : _vm._e(),
      _vm.showNicknameConfirmDialog
        ? _c("cat-nickname-confirm-dialog", {
            attrs: {
              "assistant-cat": _vm.selectedAssistantCat,
              nickname: _vm.pendingNickname,
              "is-resetting-to-default": _vm.isResettingNicknameToDefault,
            },
            on: {
              confirm: _vm.onConfirmNickname,
              close: _vm.onCloseNicknameConfirm,
            },
          })
        : _vm._e(),
      _vm.showNicknameSuccessDialog
        ? _c("cat-nickname-success-dialog", {
            attrs: {
              "assistant-cat": _vm.selectedAssistantCat,
              "reaction-message": _vm.nicknameReactionMessage,
            },
            on: { ok: _vm.onOkNicknameSuccess },
          })
        : _vm._e(),
      _vm.showFeedbackManuscriptModeDialog
        ? _c("feedback-manuscript-mode-selection-dialog", {
            attrs: { "assistant-cat-master": _vm.assistantCatMaster },
            on: { close: _vm.onCloseFeedbackManuscriptModeDialog },
          })
        : _vm._e(),
      _vm.showGenerateSummaryModeDialog
        ? _c("generate-summary-mode-selection-dialog", {
            attrs: { "assistant-cat-master": _vm.assistantCatMaster },
            on: { close: _vm.onCloseGenerateSummaryModeDialog },
          })
        : _vm._e(),
      _vm.showRequestDialog && _vm.requestAction
        ? _c("assistant-cat-home-request-dialog", {
            attrs: {
              action: _vm.requestAction,
              "writer-type": _vm.selectedCatType,
            },
            on: { close: _vm.onCloseRequestDialog },
          })
        : _vm._e(),
      _vm.showChargeBreakdownDialog
        ? _c("assistant-cat-home-charge-breakdown-dialog", {
            attrs: { "web-charge-label": _vm.formattedPrepaidFish },
            on: {
              close: function ($event) {
                _vm.showChargeBreakdownDialog = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }